import LogoPng from '../../assets/images/Trimmed_RiskyQuizness.png'

type Props = {
    className?: string,
    style?: React.CSSProperties | undefined,
}

export const Logo = ({ className, style }: Props) => {
    return (
        <img 
            className = { className }  
            style = {{ ...style, height: 'auto' }} 
            src = { LogoPng } 
            alt="Risky Quizness Logo" 
        />
    );
}